import { renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", _mergeProps(_ctx.$attrs, { class: "button" }), [
    _renderSlot(_ctx.$slots, "default")
  ], 16))
}